'use client';
'use strict';

var factory = require('../system/factory.cjs');

const Box = factory.chakra("div");
Box.displayName = "Box";

exports.Box = Box;
